import PanelLeftAdministrative from "./components/administrative/panel-administrative-left";
import PanelRightAdministrative from "./components/administrative/panel-administrative-right";
import ReportDownload from "./components/administrative/report-download/report-download";

const MobAdministrative = () => {
  return (
    <>
      <div className="d-flex flex-column w-100 h-100 gap-3">
        <div className="w-100" style={{ height: "10%" }}>
          <ReportDownload />
        </div>

        <div className="d-flex flex-row w-100 gap-3" style={{ height: "90%" }}>
          <PanelLeftAdministrative />
          <PanelRightAdministrative />
        </div>
      </div>
    </>
  );
};
export default MobAdministrative;
